import ToolSelection from '../../components/ToolSelection/ToolSelection';
import SelectedToolOptions from '../SelectedToolOptions/SelectedToolOptions';
import { useEffect, useState } from 'react';
import { Canvas } from 'fabric/fabric-impl';
import ShowIf from '../../components/UI/ShowIf';
import { EditorStore, useStore } from '../../store/createStore';

function CreationTools(props: {
  selectedCategorySettings: SelectedCategorySettings<any>;
  canvas: Canvas;
}) {
  const activeTextEditingMobile = useStore<EditorStore, any>('activeTextEditingMobile')[0];
  const [selectedTool, setSelectedTool] = useState('');
  const { toolsSelection, gallery } = props.selectedCategorySettings;

  const handleActiveSelectedTool = (keyTool: string) => {
    setSelectedTool(keyTool);
  };

  return (
    <div className="w-full h-full" style={{ display: activeTextEditingMobile ? 'none' : 'block' }}>
      <>
        <div className={`w-full h-full ${!!selectedTool ? 'selected-tool-options--active' : 'selected-tool-options--inactive'}`}>
          <SelectedToolOptions
            canvas={props.canvas}
            selectedTool={selectedTool}
            gallery={gallery}
          />
        </div>
        <ToolSelection
          onActiveSelectedTool={handleActiveSelectedTool}
          toolsSelection={toolsSelection}
        />
      </>
    </div>
  );
}

export default CreationTools;
